import CoreApi from '../../api/CoreApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';

export const meGetGamificationTier = createQueryFn(
  QueryNameSpace.meGetGamificationTier,
  async () => {
    const res = await CoreApi.meGetGamificationTier();

    return res?.tier;
  },
);
